export default __webpack_public_path__ + "static/media/Website images-15.cac6bcf9.jpg";